(function () {
  var DRAG_THRESHOLD = 5;

  function getWrapper(root) {
    return root.closest('.xo-product-info-content__complementary');
  }

  function updateVisibility(root) {
    var wrapper = getWrapper(root);
    if (!wrapper) return;

    var hasContent = !!root.querySelector('.lop-pdp-complementary__content');
    if (hasContent) {
      wrapper.removeAttribute('hidden');
    } else {
      wrapper.setAttribute('hidden', '');
    }
  }

  function fetchComplementaryProducts(root) {
    if (root.dataset.lopFetched === 'true') return Promise.resolve();
    root.dataset.lopFetched = 'true';

    var url = root.getAttribute('xo-url');
    if (!url) {
      updateVisibility(root);
      return Promise.resolve();
    }

    return fetch(url)
      .then(function (res) {
        return res.text();
      })
      .then(function (text) {
        var html = document.createElement('div');
        html.innerHTML = text;
        var recommendations = html.querySelector('xo-product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          root.innerHTML = recommendations.innerHTML;
        }
      })
      .catch(function (err) {
        console.error('[lop-pdp-complementary]', err);
      })
      .finally(function () {
        updateVisibility(root);
        initDragScroll(root.querySelector('.lop-pdp-complementary__scroll--draggable'));
      });
  }

  function initDragScroll(scrollEl) {
    if (!scrollEl || scrollEl.dataset.lopDragInit === 'true') return;
    scrollEl.dataset.lopDragInit = 'true';

    var isDown = false;
    var moved = false;
    var startX = 0;
    var startScrollLeft = 0;

    function onPointerDown(event) {
      if (event.button !== undefined && event.button !== 0) return;
      isDown = true;
      moved = false;
      startX = event.pageX;
      startScrollLeft = scrollEl.scrollLeft;
      scrollEl.classList.add('is-dragging');
    }

    function onPointerMove(event) {
      if (!isDown) return;
      var delta = event.pageX - startX;
      if (Math.abs(delta) > DRAG_THRESHOLD) {
        moved = true;
        event.preventDefault();
      }
      scrollEl.scrollLeft = startScrollLeft - delta;
    }

    function onPointerUp() {
      isDown = false;
      scrollEl.classList.remove('is-dragging');
    }

    function onClickCapture(event) {
      if (moved) {
        event.preventDefault();
        event.stopPropagation();
        moved = false;
      }
    }

    scrollEl.addEventListener('mousedown', onPointerDown);
    window.addEventListener('mousemove', onPointerMove);
    window.addEventListener('mouseup', onPointerUp);
    scrollEl.addEventListener('mouseleave', onPointerUp);
    scrollEl.addEventListener('click', onClickCapture, true);
  }

  function setupRoot(root) {
    updateVisibility(root);

    var scrollEl = root.querySelector('.lop-pdp-complementary__scroll--draggable');
    if (scrollEl) initDragScroll(scrollEl);

    if (root.dataset.lopObserverInit === 'true') return;
    root.dataset.lopObserverInit = 'true';

    var observer = new MutationObserver(function () {
      updateVisibility(root);
      initDragScroll(root.querySelector('.lop-pdp-complementary__scroll--draggable'));
    });
    observer.observe(root, { childList: true, subtree: true });

    fetchComplementaryProducts(root);
  }

  function setupAll() {
    document.querySelectorAll('.lop-pdp-complementary').forEach(setupRoot);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', setupAll);
  } else {
    setupAll();
  }
})();
